var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelpBaseBlock',{attrs:{"editnow":false,"source":"sap","editaction":"sap"}},[_c('p',[_vm._v(" Your mission statement is an important content area for SEO purposes and we encourage you to spend some time writing a well-crafted one. Consider including a paragraph about how your agency strives to embody the mission. ")]),_c('HelpNoStuff')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }